

export default class JsxUtil {

	public static highlightText(text: string, query: string | RegExp, renderMatch?: (match: string, lastIndex: number) => React.ReactNode): React.ReactNodeArray {
		if (!text || !query) {
			return [text];
		}

		let lastIndex = 0;
		const tokens: React.ReactNodeArray = [];
		const rx: RegExp = typeof query === 'string' ? new RegExp(query, "gi") : query;
		while (true) {
			const match = rx.exec(text);
			if (!match) {
				break;
			}

			const { length } = match[0];
			const before = text.slice(lastIndex, rx.lastIndex - length);
			if (before.length > 0) {
				tokens.push(before);
			}
			lastIndex = rx.lastIndex;
			if (renderMatch) {
				tokens.push(renderMatch(match[0], lastIndex));
			} else {
				tokens.push(<span key={lastIndex} className="match">{match[0]}</span>);
			}
		}

		return tokens;
	}
}



// WEBPACK FOOTER //
// ./src/core/util/JsxUtil.tsx